function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.44
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.99992 4V16H13.9999V4H1.99992ZM14.6666 1.33333V2.66667H1.33325V1.33333H5.14058C5.74058 1.33333 6.22792 0.600667 6.22792 0H9.77125C9.77125 0.600667 10.2586 1.33333 10.8586 1.33333H14.6666Z",
  fill: "#C4C4C4"
}));

function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/deleteButton.aa278ef84709d59d4a60031798143cf1.svg";
export { ForwardRef as ReactComponent };